import React from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { MdOutlineAdd, MdRefresh } from 'react-icons/md';
import { t } from '#i18n';

export const OrganizationsHeader = ({
  refreshingInstallations,
  onAddInstallation,
  onRefreshInstallations,
}) => (
  <Flex
    width="full"
    paddingX={4}
    minHeight="3.625rem"
    maxHeight="3.625rem"
    alignItems="center"
    justifyContent="space-between"
  >
    <Text fontSize="md" fontWeight="medium">{t('settings.manageOrganizations.title')}</Text>
    <Flex>
      <Button
        variant="outline"
        fontWeight="normal"
        size="sm"
        leftIcon={<MdOutlineAdd />}
        marginRight={2}
        onClick={onAddInstallation}
      >
        {t('settings.manageOrganizations.add')}
      </Button>
      <Button
        variant="outline"
        isLoading={refreshingInstallations}
        fontWeight="normal"
        size="sm"
        leftIcon={<MdRefresh />}
        onClick={onRefreshInstallations}
      >
        {t('settings.manageOrganizations.refresh')}
      </Button>
    </Flex>
  </Flex>
);
